import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { ManagePairingService } from 'src/app/services/manage-pairing.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SuccessComponent } from '../success/success.component';
import { AlertConfirmPopupComponent } from 'src/app/common/alert-confirm-popup';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, MANAGE_PAIRING } from 'src/app/common/core/common.constants';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-manage-pairing-multiline',
  templateUrl: './manage-pairing-multiline.component.html',
  styleUrls: ['./manage-pairing-multiline.component.scss']
})
export class ManagePairingMultilineComponent implements OnInit {
  authoringContentData: any;
  selectedLine: any;
  private utilsSvc: UtilsService;
  private managePairingService: ManagePairingService;
  manageLineService: ManageLineService;
  form: UntypedFormGroup;
  private fb: UntypedFormBuilder;
  ban: string;
  private modalService: NgbModal;
  submitChangeValue: boolean;
  helperUtilSvc: HelperUtilityService;
  loaderSvc: LoaderService;
  eligibleSuccess: boolean = false;
  banMsisdnSet: any;

  constructor(private injector: Injector) {
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.managePairingService = this.injector.get<ManagePairingService>(ManagePairingService);
    this.fb = this.injector.get<UntypedFormBuilder>(UntypedFormBuilder);
    this.helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.loaderSvc = this.injector.get<LoaderService>(LoaderService);
  }

  ngOnInit(): void {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.form = this.fb.group({});
    this.selectedLine[0].expendFlag = true;
    this.setTemplate();
  }
  setTemplate() {
    this.submitChangeValue = false;
    let statusRequest = {
      "billingAccount": this.ban,
      "mobileNumbers": []
    };
    for (let line of this.selectedLine) {
      line.radioOptionSelected = new UntypedFormControl('', [Validators.required]);
      line.gsmLineFormControl = new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]);
      line.digitsLineFormControl = new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]);
      line.eligibleSuccess = false;
      const digitsLine = this.managePairingService.isDIGITsLine(line?.lineType);
      const gsmLine = this.managePairingService.isGSMLine(line?.productType);
      if (digitsLine) {
        line.digitsLineFormControl.setValue(line?.msisdn);
        line.digitsLineFormControl.disable();

      } else if (gsmLine) {
        line.gsmLineFormControl.setValue(line?.msisdn);
        line.gsmLineFormControl.disable();
      }
      statusRequest.mobileNumbers.push(line?.msisdn);
      this.setRadioGroupSubscription(line);
    }
    this.getLinePairStatus(statusRequest);
  }

  getLinePairStatus(request){
    let counter = 0;
    this.loaderSvc.start();
    this.managePairingService.getPairingStatus(request).subscribe((response) =>{   
      this.loaderSvc.stop();
      this.selectedLine.forEach((line) => {
        if(this.utilsSvc.isNotNullOrUndefined(response)){
          const res = response.find((r) => r.mobileNumber === line?.msisdn);
          if(res?.paired){
            if (this.managePairingService.isDIGITsLine(line?.lineType)) {
              line.disablePair = true;
              line.radioOptionSelected.setValue(MANAGE_PAIRING.UNPAIR);
              line.gsmLineFormControl.setValue(res.pairedDetails[0]?.mobileNumber);
              line.gsmLineFormControl.disable();
              counter ++;
              line.eligibleSuccess = true;
            } else {
              line.radioOptionSelected.setValue(MANAGE_PAIRING.PAIR);
            }
          }else{
            line.radioOptionSelected.setValue(MANAGE_PAIRING.PAIR);
            line.disableUnpair = true;
          }
          this.updateLineLabels(line);
        }
      }); 
      if(counter == this.selectedLine.length){
        this.submitChangeValue = true;
      }
    }, (error) => {
      this.manageLineService.close();
      this.openErrorModal(COMMON_CONSTANTS.ALERT_TYPES.WARNING, COMMON_CONSTANTS.SERVER_ERROR_MSG);
    });
  }
  expansionPanelOpened(line) {
    line.expendFlag = true;
  }
  expansionPanelClosed(line) {
    line.expendFlag = false;
  }
  setRadioGroupSubscription(line){
    line.radioOptionSelected.valueChanges.subscribe((action) => {
      line.selectedAction = action;
      this.updateLineLabels(line);
      if(line.digitsLineFormControl.status === "DISABLED" && line.gsmLineFormControl.status === "DISABLED"){
        this.onInputEligibilityCheck(line);
      }
    });
  }
  onInputEligibilityCheck(line) {
    const invalidLines = line.gsmLineFormControl.invalid || line.digitsLineFormControl.invalid;
    const actionNotSelected = line.selectedAction == undefined;
    if (invalidLines || actionNotSelected) {
      return;
    }

    line.gsmError = false;
    line.digitError = false;

    if (!this.banMsisdnSet.has(line.gsmLineFormControl.value)) {
      line.errorMessage = this.authoringContentData.managePairing.msisdnNotUnderBAN;
      line.gsmError = true;
      line.eligibleSuccess = false;
    } else if (!this.banMsisdnSet.has(line.digitsLineFormControl.value)) {
      line.errorMessage = this.authoringContentData.managePairing.msisdnNotUnderBAN;
      line.digitError = true;
      line.eligibleSuccess = false;
    } else {
      this.checkEligibility(line);
    }
  }

  checkEligibility(line){
    const body = {
      "gsmLine": line.gsmLineFormControl.value,
      "digitsLine": line.digitsLineFormControl.value,
      "billingAccount": this.ban,
      "action": line.selectedAction
    };
    line.digitError = false;
    line.gsmError = false;
    this.loaderSvc.start();
    this.managePairingService.checkEligibility(body).subscribe((response) => {
      this.loaderSvc.stop();
      if (response?.eligible) {
        line.eligibleSuccess = true;
      } else {
        line.eligibleSuccess = false;
        if(this.managePairingService.isGSMLine(line?.productType)){
          line.errorMessage = response.errorMsg
          line.digitError = true;
        }else{
          line.errorMessage = response.errorMsg
          line.gsmError = true;
        }
      }
      this.checkEligibilitySucess();
    }, (error) => {
      this.manageLineService.close();
      this.openErrorModal(COMMON_CONSTANTS.ALERT_TYPES.WARNING, COMMON_CONSTANTS.SERVER_ERROR_MSG);
    });
  }
  checkEligibilitySucess(){
    const hasFailedEligibility = this.selectedLine.some(line => !line.eligibleSuccess);
    this.submitChangeValue = !hasFailedEligibility;
  }
  nextStep(line) {
    const nextIndex = this.selectedLine.findIndex(item => item.msisdn === line.msisdn);
    if (this.selectedLine.length -1 > nextIndex) {
      this.selectedLine[nextIndex + 1].expendFlag = true;
    }
    this.selectedLine[nextIndex].expendFlag = false;
  }
  onSubmit(){
    const authInfo = JSON.parse(sessionStorage.getItem(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    const requests = this.selectedLine.map(line => ({
      gsmLine: line.gsmLineFormControl.value,
      digitsLine: line.digitsLineFormControl.value,
      billingAccount: this.ban,
      action: line.selectedAction,
      "orgId": this.helperUtilSvc.getOrgID(),
      "logonId": !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
      "email": !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID
    }));
    const submitRequest = {
      "targetServiceName" : 'manage-pairing',
      "ban": sessionStorage.getItem(MANAGE_LINE_CONST.BAN),
      "requests": requests
    }
    this.loaderSvc.start();
    this.manageLineService.submitBulkRequest(submitRequest).subscribe(response => {
      this.loaderSvc.stop();
      if (response?.status === MANAGE_LINE_CONST.SUCCESS) {
        this.openSuccessModal(response?.token);
      } else {
        this.openErrorModal(this.authoringContentData.managePairing.submitFailedHeader, response?.errorMsg);
      }
    }, (error) => {
      this.manageLineService.close();
      this.openErrorModal(COMMON_CONSTANTS.ALERT_TYPES.WARNING, COMMON_CONSTANTS.SERVER_ERROR_MSG);
    });
  }

  openSuccessModal(transactionId) {
    const ref = this.modalService.open(SuccessComponent, {
      backdrop: "static",
      keyboard: false,
      container: '#am-container-custom',
    });
    ref.componentInstance.header = this.authoringContentData.managePairing.submitSuccessHeader;
    ref.componentInstance.modalBodyContent = this.authoringContentData.managePairing.submitSuccessBody + transactionId;
    ref.componentInstance.isConfirmationPopup = false;
  }

  openErrorModal(title, errorMsg) {
    const ref = this.modalService.open(AlertConfirmPopupComponent, {
      backdrop: "static",
      keyboard: false,
      container: '#am-container-custom',
    });
    ref.componentInstance.title = title;
    ref.componentInstance.message = errorMsg;
    ref.componentInstance.btnOkText = COMMON_CONSTANTS.OK;
  }
  termsChecked() {
    this.submitChangeValue = true;
  }
  removeLine(line){
    const index = this.selectedLine.indexOf(line);
    this.selectedLine.splice(index, 1);
    this.manageLineService.changeCurrentSelection(line);
    if (this.selectedLine.length === 0) {
      this.manageLineService.close();
    }else{
      this.selectedLine[0].expendFlag = true;
    }
    this.checkEligibilitySucess();
  }

  updateLineLabels(line) {
    const labels = this.managePairingService.getFormLineLabels(line.selectedAction, line?.lineType, line?.productType)
    line.gsmLineLabel = labels.gsmLineLabel;
    line.digitLineLabel = labels.digitLineLabel;
  }
}
